import { useNavigate } from "react-router-dom";
import { Gauge, X, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ModalOverlay } from "@/components/ui/modal-overlay";
import { Pill } from "@/components/ui/pill";
import { ProductionOrderIndicators } from "./ProductionOrderIndicators";
import { OP_STATUS_TONE, statusText } from "./production-order-utils";
import type { ProductionOrder } from "../../types/production-orders.types.js";

// Modal de indicadores consolidados por OP (artboard 04 do protótipo).
export function ProductionOrderIndicatorsDialog({
  order,
  onClose,
}: {
  order: ProductionOrder;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  return (
    <ModalOverlay onClose={onClose} title={`Indicadores · ${order.code ?? order.lineName}`}>
      <div className="flex items-start gap-3 border-b p-5">
        <span className="border-brand-500/30 flex h-9 w-9 shrink-0 items-center justify-center rounded-md border bg-brand-50 text-brand-600">
          <Gauge className="h-[18px] w-[18px]" />
        </span>
        <div className="flex-1">
          <h2 id="op-ind-title" className="text-[17px] font-semibold leading-snug">
            Indicadores · {order.code ?? order.lineName}
          </h2>
          <p className="text-xs text-text-secondary">
            {order.products.map((p) => p.name).join(", ")} · {order.lineName}
          </p>
        </div>
        <Button variant="ghost" size="icon" aria-label="Fechar" onClick={onClose}>
          <X className="h-4 w-4" />
        </Button>
      </div>
      <div className="overflow-y-auto p-5">
        <ProductionOrderIndicators orderId={order.id} />
      </div>
      <div className="flex items-center justify-between gap-2 border-t bg-bg-muted-rd px-5 py-3">
        <Pill tone={OP_STATUS_TONE[order.status]} withDot>
          {statusText(order)}
        </Pill>
        {order.productionRunId ? (
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate(`/lines/${order.lineId}/detail`)}
          >
            <Eye className="mr-1 h-4 w-4" /> Abrir run
          </Button>
        ) : null}
      </div>
    </ModalOverlay>
  );
}
